{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "لم يتم العثور على النتائج.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "لم يتم العثور على النتائج.",
    "SEARCHING": "جاري البحث..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "إلغاء",
      "CONFIRM": "تأكيد"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "البحث عن بلد",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "الرجاء تحديد رمز الاتصال من القائمة"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Author is not available"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "اعرف المزيد",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "دقائق",
    "HOURS": "ساعات",
    "DAYS": "أيام",
    "PLACEHOLDER": "أدخل المدة"
  }
}
